import { render, staticRenderFns } from "./Normatif.vue?vue&type=template&id=bc287f74&scoped=true&"
import script from "./Normatif.vue?vue&type=script&lang=js&"
export * from "./Normatif.vue?vue&type=script&lang=js&"
import style0 from "./Normatif.vue?vue&type=style&index=0&id=bc287f74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc287f74",
  null
  
)

export default component.exports